import { createFileRoute } from '@tanstack/react-router';
import posthog from 'posthog-js';

import { AuthGuard } from '@/features/auth/guards/AuthGuard';
import { AppShell } from '@/features/navigation/components/AppShell';
import { useTrackEvent } from '@/features/shared/hooks/useTrackEvent';

export const Route = createFileRoute('/_authenticated')({
	beforeLoad: async ({ context }) => {
		const user = await AuthGuard.requireAuthenticated(context.queryClient);
		if (posthog.__loaded && user) {
			posthog.identify(user.id, { email: user.email, name: user.name, role: user.role, companyId: user.companyId, companyName: user.company?.name });
			posthog.group('company', user.companyId, { name: user.company?.name });
		}
		return { user };
	},
	component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
	useTrackEvent('app_opened', undefined, { once: true });

	return <AppShell />;
}
